const EndPoints = {
  token: "edb748be-015a-4b12-9a3e-92c384016ece",
  Authorization: "Basic RlNxaDdWR1RqUzNMa3ZrcFZRSEw6WA==",
  login: "/user/login",
  getResidets: "/apartments/society/",
  updateOwner: "/apt/owner/update/",
  updateResident: "/apt/resident/update/",
  AppuserApi: "/app-user/",
  delAppuserApi: "/delete-mob",
  getValveHistory: "/valve/getValveHistory",
  status400:"Invalid request",
  status500:"An error occurred while processing the request!"


};
export default EndPoints;
